import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';

import { EventInteraction, GTMInteractions } from '../../../../shared/models/Constants';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { phoneVaidationPass } from './../../../../store/actions/authentication.actions';
import { AppState } from './../../../../store/app-reducers';

@Component({
  selector: 'input-tel',
  templateUrl: './input-tel.component.html',
  styleUrls: ['./input-tel.component.scss'],
})
export class InputTelComponent implements OnInit, OnDestroy {

  @Input() telForm: UntypedFormGroup; // Formulario de Teléfono
  @Input() spinner = false;

  constructor(
    private analytService: AnalyticsService
    , private store: Store<AppState>
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  public onSubmitTemplate = () => {
    this.telForm.get('phone').setValue(this.telForm.get('phone').value.toString().trim());
    if (this.telForm.invalid) { return; }
    this.store.dispatch(phoneVaidationPass({ Telefono: this.telForm.get('phone').value }));
    this.analytService.sendEventAnalytics(GTMInteractions.phoneRevoceryPasswordEvent, EventInteraction)
  }

}
